import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=5a16050c&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"
import style0 from "./Articles.vue?vue&type=style&index=0&id=5a16050c&prod&scoped=true&lang=scss"
import style1 from "./Articles.vue?vue&type=style&index=1&id=5a16050c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16050c",
  null
  
)

export default component.exports